<template>
  <div class="rule-form-step rule-form-step--start rule-form-step--start--step-2 flex max-w-4xl flex-col gap-5 py-5">
    <campaign-name-block :entity="entity" :disabled="!entity.isNew" />

    <campaign-budget-block :entity="entity" :disabled="$parent.readonlyMode" switchable />

    <campaign-special-ad-categories-block :entity="entity" :disabled="!entity.isNew" />
  </div>
</template>

<script>
import RuleFormStepMixin from '@/mixins/RuleForm/Step.js';
import CampaignBudgetBlock from '@/ui/components/RuleForm/Blocks/CampaignBudgetBlock.vue';
import CampaignNameBlock from '@/ui/components/RuleForm/Blocks/CampaignNameBlock.vue';
import CampaignSpecialAdCategoriesBlock from '@/ui/components/RuleForm/Blocks/CampaignSpecialAdCategoriesBlock.vue';

export default {
  name: 'StartRuleFormStep2',
  components: {
    CampaignBudgetBlock,
    CampaignNameBlock,
    CampaignSpecialAdCategoriesBlock,
  },
  mixins: [ RuleFormStepMixin ],
  watch: {
    'entity.output_campaign.bid_strategy'() {
      if (this.entity.isRoasGoalCampaignStrategy) {
        this.entity.settings.adset_conversion_location = 'website';
        this.entity.settings.adset_optimization_goal = 'VALUE';

        if (this.entity.pixelListForSelect.length > 0) {
          this.entity.settings.adset_conversion_pixel_id = this.entity.pixelListForSelect[0].value;
          this.entity.settings.adset_conversion_event = 'PURCHASE';
        }
      }
    },
  },
};
</script>
